/* wsapi3-footer-badges v1.0 */
/* Deploy Version 2026-10-14 10:42:32 */
/* Deploy Version 2026-09-24 19:11:10 */
/* Deploy Version 2026-07-27 16:11:02 */
wsMain.createModule({
  name: "footer-badges",
  version: '1.0',
  updatedAt: '2026-07-14',
  create(returnJson) {
    try {
      if (!Array.isArray(returnJson)) returnJson = [returnJson];
      returnJson.forEach(badge => {
        let li = wsMain.tools.createElm('li');

        let id = (badge.name || 'badge').trim().replace(/ /g, '');
        li.setAttribute('id', id);

        let href = badge.url?.trim() || '#';
        let holder = wsMain.tools.createElm({
          type: 'a',
          attrs: {
            class: 'badge-holder',
            id: id + '-link',
            title: badge.name || 'Selo',
            target: href != '#' && href != 'javascript:void()' ? '_blank' : '',
            href: href
          }
        });
  
        if (badge.content) {
          holder.innerHTML = badge.content;
        } else {
          holder.appendChild( wsMain.tools.createElm({
            type: 'img',
            lazyLoad: true,
            attrs: {
              width: 100,
              height: 70,
              src: badge.image,
              alt: badge.name
            }
          }));
        }
  
        li.append(holder);
        document.querySelector('[data-wsjs-badges]').append(li);
      });
    } catch(err) {}
  },
});
